<div fxLayout="column" fxLayoutWrap="wrap" style="min-width: 600px;">
    <div style="margin: 20px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <span>Detalles</span>
    </div>
    <div style="margin: 10px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <div fxFlex.gt-sm="30" fxFlex.gt-xs="30" fxFlex="30" fxLayoutAlign="space-evenly">
            <img style="height: 150px; margin-top: 30px;" *ngIf="appointment.applicant.base64Picture"
                [src]="'data:image;base64,' + appointment.applicant.base64Picture | imagePipe" />
        </div>
        <div fxFlex.gt-sm="70" fxFlex.gt-xs="70" fxFlex="70">
            <h4>Datos del solicitante</h4>
            <div style="width:100%" >
                Nombre y Apellido: {{appointment.applicant.firstName + ' ' + appointment.applicant.lastName}}
            </div>
            <div style="width:100%">
                {{appointment.applicant.docType}}: {{appointment.applicant.docNumber}}
            </div>
            <div style="width:100%">
                Fecha de Nacimiento: {{appointment.applicant.formatedBirthDate}}
            </div>
            <div style="width:100%">
                Género: {{appointment.applicant.gender}}
            </div>
            <div style="width:100%">
                Teléfono: {{appointment.phoneNumber}}
            </div>
            <ng-container *ngIf="appointment.sectionalItemRequestList">
                <div style="width:100%" *ngFor="let item of appointment.sectionalItemRequestList">
                    Tipo de trámite: {{item.sectionalItem.name}}
                </div>
            </ng-container>
            <div style="width:100%; margin: 10px 0" *ngIf="appointment.stampTickets && appointment.stampTickets.length > 0">
                <span style="font-weight: 500">Codigos de Sellado</span>
                <div *ngFor="let stampTicket of appointment.stampTickets" [value]="stampTicket" style="margin: 5px 0 5px 20px;">
                    <div *ngIf="stampTicket.transactionNumber" style="width:100%">
                        Número de Transacción: <strong>{{stampTicket.transactionNumber}}</strong>
                    </div>
                    <div *ngIf="stampTicket.controlNumber" style="width:100%">
                        Número de control: <strong>{{stampTicket.controlNumber}}</strong>
                    </div>    
                    <div style="width:100%">
                        Tipo de sellado: <strong>{{stampTicket.stamp.name}}</strong>
                    </div>            
                </div>
            </div>
            <div style="width:100%"  *ngIf="appointment.operator">
                Atendido por: {{appointment.operator.lastName}} , {{appointment.operator.firstName}}
            </div>
            <div style="width:100%" *ngIf="appointment.cancelNote">
                Motivo de cancelación: {{appointment.cancelNote}}
            </div>
            <div style="width:100%" *ngIf="appointment.absentNote">
                Motivo de ausencia: {{appointment.absentNote}}
            </div>
            <div style="width:100%" *ngIf="appointment.attendNote">
                Observación: {{appointment.attendNote}}
            </div>
         
        </div>
    </div>
    <div style="margin: 20px 0 0 0; text-align: right;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <button (click)="closeDialog()" mat-button color="primary">Cerrar</button>
    </div>
</div>